import useQueryParams from "../../../common/hooks/useQueryParams.hook";

import React from "react";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";

interface BasicPaginationProps {
    count: number;
    isLoading: boolean;
}

const BasicPagination: React.FC<BasicPaginationProps> = ({ count, isLoading }) => {
    const { queryParams, setQueryParams } = useQueryParams();
    const page = parseInt(queryParams.page) || 1;

    function handleChange(event: React.ChangeEvent<unknown>, value: number) {
        // Prevent unnecessary re-fetching
        if (page === value) return;
        setQueryParams({ ...queryParams, page: value.toString() });
    }

    return (
        <Box p={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Pagination count={count} page={page} onChange={handleChange} disabled={isLoading} />
        </Box>
    );
};

export default BasicPagination;
